/**
 * A stub for other UI components to attach to so they're not global and nicely
 * grouped together.
 *
 * BatchGeoUi's purpose is a place to hold on to small UI components that are reused.
 * For example, a login for could be BatchGeoUi.LoginForm() and you can inject that
 * into other components.
 *
 * Currently, you simply just attach directly to the object. This may change in the
 * the future but for now you would simply do something like:
 *
 * @example
 * 	BatchGeoUi.LoginForm = function () {
 * 		return $('<form />')
 * 	}
 */
(function (window) {
  window.BatchGeoUi = {};
})(window);
